<div class="content">
  <mat-icon svgIcon="surprised"></mat-icon>
  <div class="message">
    Oh no! You are using an older version of this site & some features may not work correctly.
  </div>
  <button mat-button color="primary" (click)="refreshPage()">Click here to refresh with the latest version.</button>
</div>